import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/neumorphic.css';

document.body.dataset.theme = 'neumorphic';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  React.createElement(React.StrictMode, null,
    React.createElement(App, null)
  )
);